import urlJoin from "url-join";

export const cartsListPath = "/carts";
export const cartUrl = (id: string): string => urlJoin(cartsListPath, encodeURIComponent(id));
